import classNames from 'classnames';

import Anchor from '~components/Anchor/Anchor';
import Chevron from '~images/inline/chevron.inline.svg';

type Props = {
    uri: string;
    name: string;
    color?: string;
    isHero?: boolean;
    isSinglePost?: boolean;
};

const Breadcrumb = ({
    uri,
    name,
    color = 'primary',
    isHero = false,
    isSinglePost = false,
}: Props) => {
    return (
        <Anchor
            data-qa="breadcrumb"
            to={uri}
            className={classNames(
                'hover:underline w-auto',
                `text-link md:text-${color}`,
                'print:hidden flex items-center font-semibold',
                isHero ? 'md:text-base pb-2.5' : 'text-sm'
            )}
        >
            <Chevron className={classNames(`text-${color}`, 'rotate-90 mr-1')} />
            {isSinglePost ? 'Back' : `Back to ${name}`}
        </Anchor>
    );
};

export default Breadcrumb;
